import * as React from 'react'
import ListSubheader from '@mui/material/ListSubheader'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import DoneIcon from '@mui/icons-material/Done'
import CloseIcon from '@mui/icons-material/Close'
import { LocationOn } from '@material-ui/icons'

const Filter = ({
  address,
  coordinates,
  rtype,
  diataryCallBack,
  handleFilterRestaurantByDistance,
  setLocation,
  setSortFilter,
}) => {
  const [sort, setSort] = React.useState(true)
  const [open, setOpen] = React.useState(true)
  const [openDiatery, setOpenDiatery] = React.useState(true)
  const [sortvalue, setSortvalue] = React.useState('All')
  const [diatery, setDiatery] = React.useState('')
  const [distance, setDistance] = React.useState(2)

  const handleSort = () => {
    setSort(!sort)
  }
  const handleDistance = () => {
    setOpen(!open)
  }
  const handleDiateryCollapse = () => {
    setOpenDiatery(!openDiatery)
  }
  const handleOnSortChanged = (value) => {
    console.log(value)
    setSortvalue(value)
    setSortFilter(value)
  }
  const handleDiateryClick = (val) => {
    setDiatery(val)
  }
  const handleDiateryClickRemove = (val) => {}

  return (
    <div className={'div_restaurant_filter_option'}>
      <List
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: 'background.paper',
          position: 'relative',
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="h2" id="nested-list-subheader">
            All Store
          </ListSubheader>
        }
      >
        <ListItemButton onClick={handleSort}>
          <ListItemText primary="Sort" />
          {sort ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={sort} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <FormControl sx={{ pl: 4 }}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="default"
                  onClick={() => handleOnSortChanged('All')}
                  control={<Radio checked={sortvalue === 'All'} />}
                  label="All"
                />
                <FormControlLabel
                  value="popular"
                  onClick={() => handleOnSortChanged('popular')}
                  control={<Radio checked={sortvalue === 'popular'} />}
                  label="Top Rated"
                />
                {/* <FormControlLabel value="rating" onClick={() => handleOnSortChanged("rating")} control={<Radio checked={sortvalue === "rating"} />} label="Rating" />
                                <FormControlLabel value="deliverytime" onClick={() => handleOnSortChanged("deliverytime")} control={<Radio checked={sortvalue === "deliverytime"} />} label="Delivery Time" /> */}
              </RadioGroup>
            </FormControl>
          </List>
        </Collapse>
        {rtype && rtype.length > 0 && (
          <>
            <ListItemButton onClick={handleDiateryCollapse}>
              <ListItemText primary="Diatery" />
              {openDiatery ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openDiatery} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <FormControl sx={{ pl: 4 }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="overlayfilter"
                  >
                    {rtype &&
                      rtype.map((item, index) => (
                        <Chip
                          key={index}
                          label={item}
                          onClick={() => {
                            handleDiateryClick(item)
                            diataryCallBack(item)
                          }}
                          onDelete={() => handleDiateryClickRemove(item)}
                          deleteIcon={
                            diatery === item ? <DoneIcon /> : <CloseIcon />
                          }
                        />
                      ))}
                  </Stack>
                </FormControl>
              </List>
            </Collapse>
          </>
        )}

        <ListItemButton onClick={handleDistance}>
          <ListItemText primary="Max Delivery Distance" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {coordinates !== undefined && (
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setDistance(0)
                  handleFilterRestaurantByDistance(0, 5)
                }}
                style={
                  distance === 0
                    ? { background: '#42B749' }
                    : { background: 'transparent' }
                }
              >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="5 km" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setDistance(1)
                  handleFilterRestaurantByDistance(0, 10)
                }}
                style={
                  distance === 1
                    ? { background: '#42B749' }
                    : { background: 'transparent' }
                }
              >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="10 km" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setDistance(2)
                  handleFilterRestaurantByDistance(0, 15)
                }}
                style={
                  distance === 2
                    ? { background: '#42B749' }
                    : { background: 'transparent' }
                }
              >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="15 km" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setDistance(3)
                  handleFilterRestaurantByDistance(0, 999999)
                }}
                style={
                  distance === 3
                    ? { background: '#42B749' }
                    : { background: 'transparent' }
                }
              >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="All" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={() => setLocation()}>
                <ListItemIcon>
                  <LocationOn />
                </ListItemIcon>
                <ListItemText primary={address} />
              </ListItemButton>
            </List>
          )}

          {coordinates === undefined && (
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={() => setLocation()}>
                <ListItemIcon>
                  <LocationOn />
                </ListItemIcon>
                <ListItemText primary="Set Location" />
              </ListItemButton>
            </List>
          )}
        </Collapse>
      </List>
    </div>
  )
}

export default Filter
